<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      :title="`${detailInfo.typeDesc}申请详情`"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="applyNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate
          :current="detailInfo"
          @success="handleOperateStateResults"
        />
      </div>
      <div v-loading="loading">
        <div class="main-cont">
          <div class="detail-title-name">
            {{detailInfo.businessName || '-'}}
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">
              基础信息
              <icon-status
                :color="detailInfo.status | setStatusColor('approvalStatus')"
                :status="detailInfo.statusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo" :colSpan="colSpan" />
              <jr-col :data-show="secondCol" :data="detailInfo" :colSpan="colSpan" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的应收单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.receiveList || [])"
              :tableColumn="receiveTableColumn"
            />
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的应付单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.payableList || [])"
              :tableColumn="payableTableColumn"
            />
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的付款单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.paymentList || [])"
              :tableColumn="paymentTableColumn"
            />
          </div>
        </div>
      </div>
    </finance-drawer>
    <!-- 关联应付单详情 -->
    <payable-detail
      :visible.sync="isPayableDetailShow"
      :payable-no.sync="payableNo"
    />
    <!-- 关联应收单详情 -->
    <receive-detail
      :visible.sync="isReceiveDetailShow"
      :receive-no.sync="receiveNo"
    />
    <!-- 关联付款单详情 -->
    <payment-detail
      v-if="isPaymentDetailShow"
      :visible.sync="isPaymentDetailShow"
      :payment-no.sync="paymentNo"
    />
  </div>
</template>
<script>
import { getOrderDetail } from '@/api/approval/order';
import payableDetail from '../../../receivables/components/payment-payable-detail'; // 应付单详情
import receiveDetail from '../../../receivables/components/receive-detail'; // 应收单详情
import paymentDetail from '../../../receivables/payment/components/detail'; // 付款单详情
import BtnsOperate from './btns-operate';
import { setStatusColor } from '@/filters/index';

export default {
  name: 'CancelModifyOrderDetail',
  props: {
    applyNo: {
      type: String,
      default: '',
    },
  },
  components: { payableDetail, receiveDetail, paymentDetail, BtnsOperate },
  data() {
    return {
      colSpan: {
        span: 8,
        xs: 24,
        sm: 12,
        md: 8,
      },
      detailInfo: {},
      loading: false,
      receiveNo: '', // 应收单编号
      payableNo: '', // 应付单编号
      paymentNo: '', // 付款单编号
      isReceiveDetailShow: false, // 应收单详情弹窗
      isPayableDetailShow: false, // 应付单详情弹窗
      isPaymentDetailShow: false, // 付款单详情弹窗
      // 基础信息
      firstCol: [
        { label: '申请类型:', prop: 'typeDesc' },
        { label: '业务订单号:', prop: 'orderNumber' },
        { label: '客户名称:', prop: 'businessName' },
        { label: '客户编号:', prop: 'businessNo' },
      ],
      secondCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '创建时间:', prop: 'crtime', filters: 'formatTime' },
        { label: '操作人:', prop: 'acceptUser' },
        { label: '驳回原因:', prop: 'rejectReason' },
      ],
    };
  },
  computed: {
    // 应收单表格
    receiveTableColumn() {
      const list = [
        {
          label: '应收单编号',
          prop: 'receiveNo',
          permission: 'FWS-SFKGL-YSD-XQ',
          click: (row) => {
            this.handleReceiveDetail(row);
          },
        }, {
          label: '业务订单号',
          prop: 'orderNumber',
        }, {
          label: '应收类型',
          prop: 'typeDesc',
        }, {
          label: '应收总额(元)',
          prop: 'shouldRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '实收总额(元)',
          prop: 'realAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '待收金额(元)',
          prop: 'waitRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
      ];
      return list;
    },
    // 应付单表格
    payableTableColumn() {
      const list = [
        {
          label: '应付单编号',
          prop: 'payableNo',
          permission: 'FWS-SFKGL-YFD-XQ',
          click: (row) => {
            this.handlePayableDetail(row);
          },
        },
        {
          label: '业务订单号',
          prop: 'orderNumber',
        }, {
          label: '应付类型',
          prop: 'typeDesc',
        }, {
          label: '应付金额(元)',
          prop: 'payAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '实付总额(元)',
          prop: 'paidAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '退款总额(元)',
          prop: 'refundAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
      ];
      return list;
    },
    // 付款单
    paymentTableColumn() {
      const list = [
        {
          label: '付款单编号',
          prop: 'paymentNo',
          permission: 'FWS-SFKGL-FKD-XQ',
          click: (row) => {
            this.handlePaymentDetail(row);
          },
        },
        {
          label: '业务订单号',
          prop: 'orderNumber',
        }, {
          label: '付款类型',
          prop: 'typeDesc',
        }, {
          label: '付款金额(元)',
          prop: 'payAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '付款时间',
          prop: 'payTime',
          filterName: 'formatTime',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'paymentStatus'),
        },
      ];
      return list;
    },
  },
  watch: {
    applyNo: {
      handler() {
        if (this.applyNo) {
          this.handleOpen();
        }
      },
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.isPayableDetailShow = false;
        this.isReceiveDetailShow = false;
        this.isPaymentDetailShow = false;
        this.getRefundDetail();
      });
    },
    // 获取详情接口
    async getRefundDetail() {
      try {
        this.detailInfo = {};
        if (!this.applyNo) {
          this.$message({
            message: '申请编号不能为空！！',
            type: 'warning',
          });
          return;
        }
        this.loading = true;
        const res = await getOrderDetail({ applyNo: this.applyNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 收款单确认/取消确认操作返回结果
    handleOperateStateResults() {
      this.getRefundDetail(this.applyNo);
      this.$emit('operate-success');
    },
    // 应付单详情
    handlePayableDetail(row) {
      this.payableNo = row?.payableNo || '';
      this.isPayableDetailShow = true;
    },
    // 应收单详情
    handleReceiveDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isReceiveDetailShow = true;
    },
    // 付款单详情
    handlePaymentDetail(row) {
      this.paymentNo = row?.paymentNo || '';
      this.isPaymentDetailShow = true;
    },
  },
};
</script>
<style scoped lang="scss">
.table-button {
  margin-bottom: 0;
}
</style>

